<template>
  <footer class="site-footer" v-if="showFooter || dirPage">
    <CookieLaw buttonClass="btn btn-sm btn-primary cookie-law-button" theme="black"></CookieLaw>
    <div class="footer-content-grid">

      <div class="footer-column">
        <h5 class="footer-section-header">TULUM</h5>
        <ul class="footer-nav-list">
          <li class="nav-item">
            <router-link :to="{ path: '/#event-line' }">Event Line</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'Today' }">Today</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'Clubs' }">Nightclubs</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'BeachClubs' }">Beachclubs</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'PartyCalendar' }">Party Calendar</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'Brands' }">Production Brands</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'TulumNye2025' }">New Year Festival</router-link>
          </li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">TOP CLUBS</h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/bagatelle-tulum' }">Bagatelle</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/bonbonniere-tulum' }">Bonbonniere</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/confessions-tulum' }">Confessions</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/gitano-tulum' }">Gitano</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/gitano-beach-tulum' }">Gitano Beach</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/ilios-restaurant-tulum' }">Ilios</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/mia-beach-club-tulum' }">Mia Tulum</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/papaya-playa' }">Papaya Playa</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/rosa-negra-tulum' }">Rosa Negra</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/taboo-tulum' }">Taboo Tulum</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/tantra-tulum' }">Tantra Tulum</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/vagalume-tulum' }">Vagalume Tulum</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/vesica-tulum' }">Vesica Tulum</router-link></li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">PRODUCTION BRANDS</h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><router-link :to="{ path: '/brands/ancestral-soul-tulum' }">Ancestral Soul</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/day-zero-tulum' }">Day Zero</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/keinemusik-tulum' }">Keinemusik</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/mayan-warrior-tulum' }">Mayan Warrior</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/mystical-sunset-tulum' }">Mystical Sunset</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/set-underground-tulum' }">SET Underground</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/sinner-tulum' }">Sinner</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/summerians-ibiza-tulum' }">Summerians</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/ten-ibiza-tulum' }">Ten Ibiza</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/tehmplo-tulum' }">Tehmplo</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/zamna-on-the-beach' }">Zamna On The Beach</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/zamna-tulum' }">Zamna Tulum</router-link></li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">RESOURCES</h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><router-link :to="{ name: 'Today' }">Tulum Today</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'TulumDjSchedule' }">DJ Schedule</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'Blog' }">Blog</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'Community' }">Community</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'Search' }">Search</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'TulumNightLife' }">Nightlife Guide</router-link></li>
          <li class="nav-item"><a href="https://www.instagram.com/tulum.party" target="_blank" rel="noopener noreferrer">Instagram</a></li>
          <li class="nav-item"><router-link :to="{ name: 'Faq' }"> FAQS</router-link></li>
          <li class="nav-item">
            <a target="_blank" rel="noopener noreferrer" href="https://imgix.cosmicjs.com/b71976d0-e281-11eb-b4d6-4f771ba4265e-TulumPartyAviso-Privacidad.pdf">
              Aviso Privacidad
            </a>
          </li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">
          <router-link :to="{ path: '/cancun-clubs' }">CANCUN</router-link>
        </h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><router-link :to="{ path: '/cancun-clubs/mun-nightclub-cancun' }">MUN</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/cancun-clubs/coco-bongo-cancun' }">Coco Bongo Cancun</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/cancun-clubs/confessions-cancun' }">Confessions Cancun</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/cancun-clubs/taboo-cancun' }">Taboo Cancun</router-link></li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">
          <router-link :to="{ path: '/playa-del-carmen-clubs' }">PLAYA DEL CARMEN</router-link>
        </h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><router-link :to="{ path: '/playa-del-carmen-clubs/coco-bongo-playa-del-carmen' }">Coco Bongo PDC</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/playa-del-carmen-clubs/ilios-playa-del-carmen' }">Ilios PDC</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/playa-del-carmen-clubs/martina-beach-club-playa-del-carmen' }">Martina</router-link></li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">OTHER LOCATIONS</h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><a href="https://www.cabo.party" target="_blank" rel="noopener noreferrer">LOS CABOS</a></li>
          <li class="nav-item"><router-link :to="{ name: 'CancunClubs' }">CANCUN</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'PDCClubs' }">PLAYA DEL CARMEN</router-link></li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">OTHER SERVICES</h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><router-link :to="{ name: 'ConciergeServices' }"> Concierge Services</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'WeddingPlanning' }"> Wedding Planners</router-link></li>
        </ul>
      </div>
    </div>
    <div class="footer-bottom-branding text-center">
      <img v-lazy="tulumPartyLogo" height="15" width="105" class="centered-logo" alt="tulum.party logo">
      <small class="tagline">PLAN A | SIDE B</small>
    </div>
  </footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import { mapState } from "vuex";

export default {
  name: 'ContentFooter', // Added name for the component
  components: { CookieLaw },
  computed: { // Corrected computed syntax
    ...mapState({ // Spread mapState directly into computed
      showFooter: (state) => state.showFooter,
    })
  },
  props: ['dirPage'],
  data() { // Corrected data syntax
    return {
      tulumPartyLogo: 'https://imgix.cosmicjs.com/3acdf350-9b87-11ee-b34c-99d1d89e42eb-tp-logo-40pt.png?w=105&h=15&fit=clamp',
      // insta property was not used in the template, so it's removed for now.
      // insta:"https://imgix.cosmicjs.com/6d099b90-5c09-11ec-a8a3-53f360c99be6-instagram.png?h=17&w=17&auto=format"
    };
  },
};
</script>

<style scoped>
.site-footer {
  margin: 0;
  background-color: #0e0e0e !important;
  color: #c0c0c0; /* Light grey for text for better readability */
  font-size: 0.85rem;
}

.cookie-law-button {
  /* Styles for CookieLaw button are often controlled by its props,
     but you can add overrides if needed */
  /* Example: margin: 10px; */
}

.footer-content-grid {
  display: flex;
  flex-wrap: wrap; /* Allow columns to wrap on smaller screens */
  justify-content: space-around; /* Distribute space */
  border-top: 1px solid mediumaquamarine;
  padding: 25px 15px; /* Added more vertical padding */
  background-color: #1c1c1c;
  /* opacity: 1 !important; */ /* Opacity is generally not needed or can cause issues */
}

.footer-column {
  /* Using flex-basis for better responsive column sizing.
     On small screens, they'll stack. On larger, they'll fit.
     Example: 4 columns for medium screens, 2 for small.
  */
  flex: 1 1 200px; /* Grow, shrink, basis */
  min-width: 180px; /* Minimum width before wrapping */
  padding: 10px 15px; /* Padding within each column */
  box-sizing: border-box;
}

.footer-section-header {
  color: #ffffff; /* White or very light grey for headers */
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 15px; /* More space below header */
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #333; /* Subtle separator for header */
  padding-bottom: 8px;
}
.footer-section-header a {
  color: inherit; /* Make router-link inherit header color */
  text-decoration: none;
}
.footer-section-header a:hover {
  color: mediumaquamarine; /* Hover effect for linked headers */
}


.footer-nav-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
  /* z-index: 10; */ /* z-index on ul is usually not necessary unless specific stacking issues */
}

.footer-nav-list .nav-item {
  margin-bottom: 8px; /* Space between list items */
}

.footer-nav-list .nav-item a {
  color: #b0b0b0; /* Slightly lighter than base text for links */
  text-decoration: none;
  transition: color 0.2s ease-in-out;
}

.footer-nav-list .nav-item a:hover {
  color: #ffffff; /* Brighter on hover */
  text-decoration: underline;
}

.footer-bottom-branding {
  padding: 25px 15px; /* More padding */
  background-color: #111111; /* Slightly different shade for bottom */
  border-top: 1px solid #2a2a2a;
}

.centered-logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 5px; /* Space between logo and tagline */
}

.tagline {
  font-weight: normal;
  font-size: 0.7rem; /* Smaller tagline */
  color: #888888;
  letter-spacing: 0.5px;
}

/* Responsive adjustments for columns if needed, though flex-wrap should handle most cases */
@media (max-width: 768px) {
  .footer-column {
    flex-basis: 45%; /* Roughly 2 columns on medium screens */
    margin-bottom: 20px; /* Space when columns stack */
  }
}

@media (max-width: 576px) {
  .footer-column {
    flex-basis: 100%; /* Single column on small screens */
  }
  .footer-section-header {
    font-size: 0.9rem;
  }
  .site-footer {
    font-size: 0.8rem;
  }
}
</style>
